import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

const Documentation = () => {
  const navigate = useNavigate();
  
  const articles = [
    {
      title: "Passport and ID Requirements",
      description: "Learn about the required identification documents and passport specifications",
      path: "/knowledge-base/documentation/passport-requirements"
    },
    {
      title: "Proof of Income Documentation",
      description: "Understanding the financial documents needed to prove sufficient means of support",
      path: "/knowledge-base/documentation/income-proof"
    },
    {
      title: "Housing Documentation Guide",
      description: "Required documents to prove your accommodation status in Poland",
      path: "/knowledge-base/documentation/housing-guide"
    },
    {
      title: "Health Insurance Requirements",
      description: "Guide to health insurance documentation for your residence permit",
      path: "/knowledge-base/documentation/health-insurance"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <FileText className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Documentation Guide
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Complete guide to all required documents for your Polish residence permit
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <Card 
              key={index}
              className="hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer"
              onClick={() => navigate(article.path)}
            >
              <CardHeader>
                <CardTitle className="text-xl text-foreground">{article.title}</CardTitle>
                <CardDescription className="text-muted-foreground">
                  {article.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Knowledge Base
          </button>
        </div>
      </div>
    </div>
  );
};

export default Documentation; 